<template>
  <div>
    <span class="info-label">{{ label }}</span>
    <vx-tooltip
      :title="title"
      :color="color"
      :position="position"
      :delay="delay"
      :min-width="minWidth"
      :z-index="zIndex"
      class="info-mark"
    >
      <template #text>
        <p class="px-2 whitespace-pre-line">
          {{ text }}
        </p>
      </template>
      <VueFeather
        type="info"
        class="feather-icon feather-icon-css-target"
      />
    </vx-tooltip>
  </div>
</template>

<script>
import VxTooltip from '@/components/vx-tooltip/VxTooltip.vue'
export default {
  name: 'VxLabelTooltip',
  components: { VxTooltip },
  props: {
    label: {
      type: String,
      default: null
    },
    text: {
      type: String,
      default: null
    },
    title: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: null
    },
    position: {
      type: String,
      default: 'top'
    },
    delay: {
      type: [Number, String],
      default: '0s'
    },
    minWidth: {
      type: [String],
      default: 'auto'
    },
    zIndex: {
      type: String,
      default: null
    }
  }
}
</script>

<style scoped>
.feather-icon-css-target :deep(.vue-feather__content) {
  width: 1rem !important;
  height: 1rem !important;
}
.info-label {
  padding-left: 5px;
  font-size: .85rem;
  color: rgba(0,0,0,.7);
}
.info-mark {
  padding-left: 5px;
  display: inline-block;
  line-height: 1;
  vertical-align: middle;
}
.no-label div.vs-component.vs-con-input-label.vs-input.vs-input-primary {
  width: auto;
}
div.vs-component :deep(div.vs-con-input i.vs-icon) {
  top: 0.75rem;
  z-index: 10;
}
</style>
